import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../App";
import axios from "axios";
import { API_URL } from "../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { handleUserLevelAccessPermissions, validateRolesIIPHQ } from "../../../Custom/Custom";
import { ToastContainer, toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { generateExcelIIP } from "./ExportIIPExcel";
import titlesData from '../../../titles.json';
import iipTitle from '../../../iip.json';


const IIPAnnualAgricultureReport = () => {

  const [years, setYears] = useState([]);
  const [yearName, setYearName] = useState("");
  const [IIPAnnualAgricultureReportData, setIIPAnnualAgricultureReportData] = useState([]);
  const [IIPAnnualAgricultureReportbaseYear, setIIPAnnualAgricultureReportbaseYear] = useState(null);
  const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
  });
  const [yearNameNextTitle, setYearNameNextTitle] = useState([]);
  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };


  const storedLanguage = localStorage.getItem('language');

  //get next Years 
  const getNextYear = (year) => {
    const nextYear = parseInt(year) + 1;
    return `${year}-${nextYear}`;
  };



  //get Years 
  const getAllYears = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth(); 
    const currentFinancialYearStart = currentMonth < 3 ? currentYear - 1 : currentYear;
    
    const yearsArray = [];
    for (let year = currentFinancialYearStart; year >= 2021; year--) {
      yearsArray.push(year);
    }
    return yearsArray;
  };


  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);
    const getYearList = () => {
      setYears(getAllYears());
    };

    const userRole = async () => {
      showLoading(true);
      try {
        const role = await validateRolesIIPHQ(decode_token);
        if (role) {
          getYearList();
        } else {
          alert(
            "You are not an authorized for IIP Report."
          );
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false);
      } finally {
        showLoading(false);
      }
    };

    userRole();
  }, []);



  const handleDropdownChange = (e) => {

    switch (e.target.name) {
      case 'year_name':
        let postData = {
          Year: e.target.value,
        }
        setYearName(e.target.value)
        onChangeAnnualAgricultureProductionDetails(postData)
        break;
      default:
        console.log("switch case are not match");
        break;

    }
  }

  const onChangeAnnualAgricultureProductionDetails = async (postData) => {
    showLoading(true);

    try {
      const response = await axios.post(`${API_URL}api/iipReports/AnnualAgricultureReportData`, postData, config);
      const allData = response.data.data;
      const AnnualAgricultureProductionData = allData[0].GroupCodes


      if (AnnualAgricultureProductionData && AnnualAgricultureProductionData.length > 0) {
        const mappedData = [];

        AnnualAgricultureProductionData.forEach(group => {
          // Add group data
          mappedData.push({
            groupName: group.GROUP_NAME,
            weight: group.Weight,
            baseVolume: group.BaseVolume,
            volumeF: group.VolumeF,
            indexF: group.IndexF,
            IWF: group.IWF,
            volumeP: group.VolumeP,
            indexP: group.IndexP,
            IWP: group.IWP,
            volumeQ: group.VolumeQ,
            indexQ: group.IndexQ,
            IWQ: group.IWQ,
            type: "group"
          });

          group.subGroups.forEach(subGroup => {
            // Add subgroup data
            mappedData.push({
              subgroupName: subGroup.SUBGROUP_NAME,
              weight: subGroup.Weight,
              baseVolume: subGroup.BaseVolume,
              volumeF: subGroup.VolumeF,
              indexF: subGroup.IndexF,
              IWF: subGroup.IWF,
              volumeP: subGroup.VolumeP,
              indexP: subGroup.IndexP,
              IWP: subGroup.IWP,
              volumeQ: subGroup.VolumeQ,
              indexQ: subGroup.IndexQ,
              IWQ: subGroup.IWQ,
              type: "subgroup"
            });

            subGroup.itemCodes.forEach(item => {
              // Add item data
              mappedData.push({
                itemName: item.itemName,
                weight: item.Weight,
                baseVolume: item.BaseVolume,
                volumeF: item.VolumeF,
                indexF: item.IndexF,
                IWF: item.IWF,
                volumeP: item.VolumeP,
                indexP: item.IndexP,
                IWP: item.IWP,
                volumeQ: item.VolumeQ,
                indexQ: item.IndexQ,
                IWQ: item.IWQ,
                type: "item"
              });
            });
          });
        });

        setIIPAnnualAgricultureReportData(mappedData);
        setIIPAnnualAgricultureReportbaseYear(postData.baseYear)
      }



    } catch (error) {
      console.error('Error posting data:', error);
    } finally {
      showLoading(false);
    }
  }

  const ExcelJS = require('exceljs');


function getCurrentDateTime() {
  const now = new Date();

  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const day = now.getDate().toString().padStart(2, '0');
  const year = now.getFullYear();

  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');

  return `${month}/${day}/${year}, ${hours}:${minutes}:${seconds}`;
}


  const handleGenerateExcel = async () => {
    const excelFileName = "IIPAgricultureReport";

    const excelObjectData = {
      fileName: excelFileName,
      reportType: excelFileName,
      fileType: 'xls',
      sheetName: excelFileName,
      firstRowMergeCells: "A1:L1",
      firstRowExportDate: getCurrentDateTime(),
      // firstRowExportDate: 'AGRICULTURE PRODUCTION (VOLUME) INDEX OF U.P',
      // firstRowCellNumber: 12,
      // secondRowMergeCells: "A2:L2",
      // secondRowText: `BASE(AGR.YEAR 2011-12)`,
      // thirdRowMergeCells: "A3:L3",
      // thirdRowText: "AGRICULTURE SECTOR",

      firstRowCellNumber: 12,
      secondRowMergeCells: "A2:L2",
      secondRowText: `AGRICULTURE PRODUCTION (VOLUME) INDEX OF U.P`,
      thirdRowMergeCells: "A3:L3",
      thirdRowText: "BASE(AGR.YEAR 2011-12)",
      fourthRowMergeCells: "A4:L4",
      fourthRowText: "AGRICULTURE SECTOR",


      baseYear:yearName,
      headerEnglishColumns: [
        'Group/Items', 'Weight', '2011 - 12 Base Volume (Th.M.T.)', 'Volume (Th.M.T)', 'Index ', 'IW', 'Volume (Th.M.T)', 'Index', 'IW', 'Volume (Th.M.T)', 'Index', 'IW']
    };

    const transformedData = [];

    IIPAnnualAgricultureReportData.forEach(item => {
      if (item.groupName) {
        transformedData.push([
          item.groupName,
          (parseFloat(item.weight) || 0).toFixed(3),
          (parseFloat(item.baseVolume) || 0).toFixed(3),
          // (parseFloat(item.volumeF) || 0).toFixed(2),
          item.volumeF,
          (parseFloat(item.indexF) || 0).toFixed(2),
          (parseFloat(item.IWF) || 0).toFixed(4),
          // (parseFloat(item.volumeP) || 0).toFixed(2),
          item.volumeP,
          (parseFloat(item.indexP) || 0).toFixed(2),
          (parseFloat(item.IWP) || 0).toFixed(4),
          // (parseFloat(item.volumeQ) || 0).toFixed(2),
          item.volumeQ,
          (parseFloat(item.indexQ) || 0).toFixed(2),
          (parseFloat(item.IWQ) || 0).toFixed(4),
          
        ]);
      }

      if (item.subgroupName) {
        transformedData.push([
          item.subgroupName,
          (parseFloat(item.weight) || 0).toFixed(3),
          (parseFloat(item.baseVolume) || 0).toFixed(3),
          // (parseFloat(item.volumeF) || 0).toFixed(2),
          item.volumeF,
          (parseFloat(item.indexF) || 0).toFixed(2),
          (parseFloat(item.IWF) || 0).toFixed(4),
          // (parseFloat(item.volumeP) || 0).toFixed(2),
          item.volumeP,
          (parseFloat(item.indexP) || 0).toFixed(2),
          (parseFloat(item.IWP) || 0).toFixed(4),
          // (parseFloat(item.volumeQ) || 0).toFixed(2),
          item.volumeQ,
          (parseFloat(item.indexQ) || 0).toFixed(2),
          (parseFloat(item.IWQ) || 0).toFixed(4),

        ]);
      }

      if (item.itemName) {
        transformedData.push([
          item.itemName,
          (parseFloat(item.weight) || 0).toFixed(3),
          (parseFloat(item.baseVolume) || 0).toFixed(2),
          (parseFloat(item.volumeF) || 0).toFixed(2),
          (parseFloat(item.indexF) || 0).toFixed(2),
          (parseFloat(item.IWF) || 0).toFixed(4),
          (parseFloat(item.volumeP) || 0).toFixed(2),
          (parseFloat(item.indexP) || 0).toFixed(2),
          (parseFloat(item.IWP) || 0).toFixed(4),
          (parseFloat(item.volumeQ) || 0).toFixed(2),
          (parseFloat(item.indexQ) || 0).toFixed(2),
          (parseFloat(item.IWQ) || 0).toFixed(4),

        ]);
      }
    });
    excelObjectData.excelRowData = transformedData;

    //console.warn("transformedData", transformedData)
    //console.warn("excelObjectData", excelObjectData)


    generateExcelIIP(excelObjectData)
  };

  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? iipTitle.hi.ANNUAL_AGRICULTURE_REPORT : iipTitle.en.ANNUAL_AGRICULTURE_REPORT }} />               
              </h4>

              <div className="row align-items-center">

                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label> {storedLanguage === 'hi' ? titlesData.hi.YEAR : titlesData.en.YEAR}</label>
                  <select
                    name="year_name"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={yearName}
                  >
                    <option value="" disabled>
                      Select Year
                    </option>
                    {years &&
                      years.map((ele, index) => (
                        <option key={index} value={ele}>
                          {getNextYear(ele)}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-xl-2 col-lg-12 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                </div>


              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}


export default IIPAnnualAgricultureReport;